<template>
  <section class="column">
    <table-unidades :id="userId" />
    <q-separator style="margin-top: 20px" />

    <table-centros class="q-mt-md" :id="userId" />
  </section>
</template>

<script setup>
import { computed } from "@vue/reactivity";
import { defineProps } from "vue";
import TableCentros from "./TableCentros.vue";
import TableUnidades from "./TableUnidades.vue";

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);
</script>

<style></style>
